import { useTranslation } from 'react-i18next';
import { NewDropdown } from 'app/components/ui';

export type TaggingSubMode = 'tag' | 'mark-coverage';

interface TaggingSubModePickerProps {
  currentValue: TaggingSubMode;
  onChange: (value: TaggingSubMode) => void;
}

export const TaggingSubModePicker = ({ currentValue, onChange }: TaggingSubModePickerProps) => {
  const { t } = useTranslation('tag');

  const options = [
    {
      label: t('coverage.submode.tag.label'),
      value: 'tag',
      icon: <i className="fa-regular fa-lg fa-tag" />,
    },
    {
      label: t('coverage.submode.markCoverage.label'),
      value: 'mark-coverage',
      icon: <i className="fa-regular fa-lg fa-highlighter" />,
    },
  ];

  return <NewDropdown variant="rounded" currentValue={currentValue} options={options} onUpdate={(value) => onChange(value as TaggingSubMode)} />;
};
